










































































































































import { Component } from 'vue-property-decorator';

import Page from '@/componentsV2/molecules/Page/Page.vue';
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import InfoIcon from '@/components/icons/Info.vue';

import eventBus from '@/utils/eventBus';
import { updateRegistration } from '@/utils/updateRegistration';
import CustomerImportBanner from '@/componentsV2/templates/CustomerImportBanner/CustomerImportBanner.vue';
import SellCoinsCampaignList from '@/componentsV2/templates/SellCoinsCampaignList/SellCoinsCampaignList.vue';
import ArrowBanner from '@/components/icons/ArrowBanner.vue';
import Picture from '@/components/atoms/Picture/Picture.vue';

import BusinessWalletService from '@/api/BusinessWalletService';
import BusinessService from '@/api/BusinessService';
import SellCoinsOverview from '@/componentsV2/templates/SellCoinsOverview/SellCoinsOverview.vue';
import { BusinessWalletDashboard } from '@/api/interfaces/business-wallet-dashboard.interface';
import { DashboardScreen } from '@/api/enums/dashboard-screen.enum';

import { needLaunchRewardsProgram } from '@/utils/start-guide';
import flagKeys from '@/constants/flagKeys';
import BannerActivateWidget from '@/components/molecules/BannerActivateWidget/BannerActivateWidget.vue';
import { treatError } from '@/utils';
import {
  EBillingStatusTypes,
  EBusinessUserType
} from '@/store/modules/businessTypes';
import SellCoinsEmptyState from '@/componentsV2/organisms/SellCoins/SellCoinsEmptyState.vue';
import BillingNetworkTag from '@/componentsV2/atoms/BillingNetworkTag/BillingNetworkTag.vue';
import BannerActivateBilling from '@/components/molecules/BannerActivateBilling/BannerActivateBilling.vue';
import SellCoinsService from '@/api/SellCoinsService';
import BillingService from '@/api/BillingService';
import {
  EAutomaticCampaignName,
  ESellCoinsCampaignStatus
} from '@/models/sell-coins';
import { EProgramStatusStatus } from '@/models/program-status';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import { appIsActive, widgetIsActive } from '@/router/validators/utils';
import BannerReactiveBilling from '@/components/molecules/BannerReactiveBilling/BannerReactiveBilling.vue';
import { IBusinessType } from '../../../models/business';
import BillingModel from '@/views/Models/BillingModel.vue';
import CoinsOverviewGrid from '@/componentsV2/templates/CoinsOverviewGrid/CoinsOverviewGrid.vue';
import { getDataOptional } from '@/utils/dashboardUtils';
import { AnalyticsCardListItem } from '@/componentsV2/organisms/AnalyticsCardList/AnalyticsCardList.vue';
import RecommendationCard from '@/componentsV2/molecules/RecommendationCard/RecommendationCard.vue';
import SellCoinsSoldChart from '@/componentsV2/templates/SellCoinsSoldChart/SellCoinsSoldChart.vue';
import { setUpSellCoins } from '@/utils/sellCoinsUtils';

export const ALREADY_ACCESSED_SELL_COINS = '@twism.already-accessed-sell-coins';

@Component({
  components: {
    Page,
    Checkbox,
    InfoIcon,
    CustomerImportBanner,
    ArrowBanner,
    Picture,
    SellCoinsOverview,
    SellCoinsCampaignList,
    BannerActivateWidget,
    SellCoinsEmptyState,
    BillingNetworkTag,
    BannerActivateBilling,
    BannerReactiveBilling,
    Typography,
    CoinsOverviewGrid,
    RecommendationCard,
    SellCoinsSoldChart
  }
})
export default class SellCoins extends BillingModel {
  dashboardData: BusinessWalletDashboard | null = null;
  businessWalletService: BusinessWalletService = new BusinessWalletService();
  businessService = new BusinessService();
  billingService = new BillingService();
  sellCoinsService = new SellCoinsService();
  loading: boolean = false;

  loadingBtnEmptyState: boolean = false;

  campaigns: any[] | null = null;

  showEmptyState = false;

  get tPrefix() {
    return 'sellCoins';
  }

  get emptyCampaign() {
    return new Date();
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessState'] || {};
  }

  get widgetDeactivated() {
    return (
      !widgetIsActive() &&
      this.flags.includes(flagKeys.widgetDeactivationAlerts) &&
      this.businessInfo.type == IBusinessType.ONLINE &&
      appIsActive()
    );
  }

  get recommendationCardProps() {
    return {
      src: require(`@/assets/img/sellCoins/banner${
        this.$mobileCheck() ? '-mobile' : ''
      }.png`),
      text:
        'Dive deeper into your <br/><span style="font-weight: 700;">revenue and coin sales</span> <br/>performance!',
      buttonText: 'See Revenue Reports',
      onClick: this.onClick,
      buttonTextColor: '#fff',
      buttonBackgroundColor: 'transparent',
      backgroundColor: '#FF5E00',
      textColor: '#fff'
    };
  }

  onClick() {
    this.$router.push('/revenue-reports');
  }

  get tOverviewPrefix() {
    return 'sellCoins.overview';
  }

  get additionalCards(): AnalyticsCardListItem[] {
    return [
      {
        variant: 'white',
        insightVariant: 'regular',
        infos: {
          title: '',
          largeTitle: String(
            this.$t(`${this.tOverviewPrefix}.cards.coinsCustomers.label`)
          ),
          disableAbbreviateAmount: true,
          tooltipIconPlacement: 'after-title',
          amount: getDataOptional(
            this.dashboardData,
            'formatted.coins.coinInCustomerWallet.amount',
            '--'
          ),
          tooltipText: String(
            this.$t(`${this.tOverviewPrefix}.cards.coinsCustomers.tooltip`)
          ),
          insightText: String(
            this.$t(`${this.tOverviewPrefix}.cards.coinsCustomers.insight`)
          ),
          counterFractionDigits: 2
        },
        components: {
          counter: {
            as: 'CoinsIcon',
            size: '36px'
          }
        }
      }
    ];
  }

  get alreadyAccessedSellCoins(): boolean {
    const storage = JSON.parse(
      localStorage.getItem(ALREADY_ACCESSED_SELL_COINS) || '{"value": false}'
    );
    return storage.value && this.businessInfo.id === storage.id;
  }

  get showWidgetBanner() {
    return !this.inactiveBilling && this.widgetDeactivated;
  }

  get isShowEmptyState() {
    return (
      (this.campaigns === null || this.campaigns.length == 0) &&
      !this.alreadyAccessedSellCoins
    );
  }

  get canEnableSellCoins() {
    return !this.showWidgetBanner && !this.toBeCanceledBilling;
  }

  get canManageSellCoins() {
    return (
      !this.showActivateBillingBanner &&
      !this.showWidgetBanner &&
      !this.toBeCanceledBilling
    );
  }

  get isNeedLaunchRewardsProgram() {
    return needLaunchRewardsProgram();
  }

  get showCustomerImportBanner() {
    return (
      this.canManageSellCoins &&
      !this.businessInfo.sellCoins &&
      !this.isNeedLaunchRewardsProgram &&
      !this.showActivateBillingBanner &&
      !this.$mobileCheck()
    );
  }

  get showActivateBillingBanner() {
    return !this.loading && this.inactiveBilling;
  }

  get showBillingTag() {
    if (!this.flags.includes(flagKeys.billingModuleV2)) return false;
    return (
      !this.loading &&
      this.billingStatus !== EBillingStatusTypes.UNAVAILABLE &&
      !this.showEmptyState
    );
  }

  get toBeCanceledBilling() {
    if (!this.flags.includes(flagKeys.billingModuleV2)) return false;

    return this.billingStatus === EBillingStatusTypes.TO_BE_CANCELED;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get welcomeCtaText() {
    return 'Explore Sell Coins';
  }

  get isCampaignManagementActive() {
    return this.flags.includes(flagKeys.sellCoinsCampaignManagement);
  }

  changedCampaigns(data: any) {
    this.campaigns = data;
  }

  async fetchDashboardData() {
    this.loading = true;

    try {
      const { data } = await this.businessWalletService.getDashboard();

      if (data && data.coins && data.coins.sold && data.coins.sold.amount > 0) {
        this.setAccessedEmptyState();
      }
      this.dashboardData = data;
    } finally {
      this.loading = false;
    }
  }

  // TODO: CREATE A HELPER/UTILS/METHOD
  updateBusinessData(data: any) {
    this.$store.dispatch('business/SET_BUSINESS_INFO', {
      ...this.businessInfo,
      sellCoins: data.sellCoins
    });
  }

  async setUpSellCoins() {
    try {
      if (this.inactiveBilling) {
        this.loadingBtnEmptyState = true;
      }

      const result = await setUpSellCoins({
        inactiveBilling: this.inactiveBilling,
        managerRole: this.$store.getters['business/getManagerRole'],
        notification: this.$notification,
        welcomeCtaText: this.welcomeCtaText,
        setAccessedEmptyState: () => {
          this.showEmptyState = false;
          this.setAccessedEmptyState();
        }
      });

      if (!this.inactiveBilling && result) {
        this.showEmptyState = false;
        this.setAccessedEmptyState();
      }
    } finally {
      if (this.inactiveBilling) {
        this.loadingBtnEmptyState = false;
      }
    }
  }

  treatErrorSellCoins(error: any) {
    if (
      error.response.data.message[0].translation ===
      'exceptions.business.sellCoinsNotAvailable'
    ) {
      this.$notification(
        'You need to connect an online provider first.',
        'error'
      );
      return;
    }

    treatError(error);
  }

  // TODO: add error handling
  verifyAndOpenActivateModal() {
    if (!location.search.match(/activate/g)) {
      return;
    }

    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        icon: 'none',
        hideCancelButton: true,
        confirmEvent: '',
        componentToRender: 'activeSellCoins'
      }),
      {
        onConfirm: async (sellCoins: boolean) => {
          const response = await this.businessService.updateSellCoins(
            sellCoins,
            DashboardScreen.Tip
          );

          if (response.status !== 200) this.treatErrorSellCoins(response);

          if (!response.data) return;

          this.updateBusinessData(response.data);

          return response.data;
        },
        onClose: () => {
          this.$router.replace(
            this.$router.currentRoute.fullPath.replace(/activate/, '')
          );
        }
      }
    );
  }

  // TODO: add error handling
  async toggleSellCoins() {
    if (this.showActivateBillingBanner) {
      eventBus.$emit('upgradeBillingBanner', false);
      return;
    }
    const componentToRender = !this.businessInfo.sellCoins
      ? 'enableSellCoins'
      : 'disableSellCoins';

    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        icon: 'none',
        hideCancelButton: true,
        confirmEvent: '',
        componentToRender
      }),
      {
        onConfirm: async () => {
          const response = await this.businessService.updateSellCoins(
            !this.businessInfo.sellCoins,
            DashboardScreen.Dashboard
          );
          if (response.status !== 200) this.treatErrorSellCoins(response);

          if (!response.data) return;

          this.updateBusinessData(response.data);
          if (componentToRender === 'enableSellCoins') {
            updateRegistration('selling-your-coins');
          }

          const coinRewardPercentage =
            this.$store.getters['business/getBusinessState'] &&
            this.$store.getters['business/getBusinessState']
              .coinRewardPercentage;
          const coinRewardStatus =
            this.$store.getters['business/getRewardStatus'] &&
            this.$store.getters['business/getRewardStatus'].rewardStatus;
          const isLoyaltRewardActive =
            coinRewardStatus === EProgramStatusStatus.ACTIVE ||
            coinRewardStatus === EProgramStatusStatus.PARTIALLY_ACTIVE ||
            coinRewardStatus === EProgramStatusStatus.PENDING;

          if (
            this.businessInfo.sellCoins &&
            this.$store.getters['flags/getFlags'].includes(
              flagKeys.dashboardSellCoinsAndLoyaltVerify
            )
          ) {
            const listOfCampaigns = await this.sellCoinsService.listOfCampaigns();
            const hasAutomaticLoyaltCampaignCreated =
              listOfCampaigns.data &&
              listOfCampaigns.data.items.length === 1 &&
              listOfCampaigns.data.items[0].status ===
                ESellCoinsCampaignStatus.INACTIVE &&
              listOfCampaigns.data.items[0].name ===
                EAutomaticCampaignName.loyalt;

            const hasNoCampaign =
              listOfCampaigns.data && !listOfCampaigns.data.items.length;

            const campaignActiveWithSameOrHigherLoyaltRatio = listOfCampaigns.data.items.find(
              (item: any) =>
                item.incentiveValue >= parseFloat(coinRewardPercentage) &&
                item.status == 'active'
            );

            const hasCampaignWithLowerLoyaltRatio =
              isLoyaltRewardActive &&
              !campaignActiveWithSameOrHigherLoyaltRatio;

            if (hasAutomaticLoyaltCampaignCreated) {
              this.loading = true;
              await this.sellCoinsService.changeCampaignStatus(
                listOfCampaigns.data.items[0].id
              );
              this.loading = false;
            } else if (hasCampaignWithLowerLoyaltRatio) {
              this.loading = true;

              await this.sellCoinsService.deactivateActiveCampaign();
              await this.sellCoinsService.createSellingCoinsCampaign({
                name: EAutomaticCampaignName.loyalt,
                incentiveValue: parseFloat(coinRewardPercentage),
                incentiveType: 'bonus',
                automaticallyCreated: true
              });
              this.loading = false;
            } else if (hasNoCampaign) {
              this.loading = true;
              await this.sellCoinsService.createSellingCoinsCampaign({
                name: EAutomaticCampaignName.first,
                incentiveValue: 0,
                incentiveType: 'bonus',
                automaticallyCreated: true
              });
              this.loading = false;
            }
          }

          return response.data;
        }
      }
    );
  }

  setAccessedEmptyState() {
    localStorage.setItem(
      ALREADY_ACCESSED_SELL_COINS,
      JSON.stringify({ id: this.businessInfo.id, value: true })
    );
  }

  async mounted() {
    if (this.businessInfo.sellCoins) this.setAccessedEmptyState();
    this.$showLoaderWithLocker();
    this.verifyAndOpenActivateModal();
    await this.fetchDashboardData();
    this.showEmptyState = this.isShowEmptyState;
    this.$hideLoader();
  }
}
